export default __webpack_public_path__ + "static/media/846.79530322.gif";